// src/servicerequests/utils.js

import { usePermissions } from "react-admin";

export const ROLES = {
  SERVICE: "service",
  SERVICE_ADMIN: "serviceadmin",
  ADMIN: "winco",
};

export const SERVICE_STATUS = {
  PENDING: "PENDIENTE",
  PARTS_TO_SEND: "REPUESTOS_A_ENVIAR",
  PARTS_SENT: "REPUESTOS_ENVIADOS",
  FINISHED: "FINALIZADO",
  ERROR: "ERROR",
};

export const useServicePermissions = () => {
  const { permissions } = usePermissions();

  return {
    isServiceRole: permissions === ROLES.SERVICE,
    isServiceAdmin: permissions === ROLES.SERVICE_ADMIN,
    isWincoAdmin: permissions === ROLES.ADMIN,
    canCreate: permissions === ROLES.SERVICE,
    canEdit:
      permissions === ROLES.SERVICE || permissions === ROLES.SERVICE_ADMIN,
    canEditStatus: permissions === ROLES.SERVICE_ADMIN,
    canEditSpareParts:
      permissions === ROLES.SERVICE_ADMIN || permissions === ROLES.SERVICE,
  };
};

export const transformData = (data) => {
  const transformedData = { ...data };
  ["product", "service", "user"].forEach((field) => {
    if (transformedData[field]) {
      transformedData[field] =
        typeof transformedData[field] === "object"
          ? transformedData[field].id
          : transformedData[`${field}.id`] || transformedData[field];
    }
  });
  return transformedData;
};
